export enum EAuthenticationType {
    Geopost = 0,
    Okta = 1
}